import { isMobile } from '../modules/utils';

function toggle(event) {
  event.preventDefault();
  const data = event.currentTarget.dataset.toggle;
  const btn = event.currentTarget;
  const element = data === 'true' ? event.currentTarget : document.querySelector(`.${data}`);

  if (!element.classList.contains('is-active')) {
    element.classList.add('is-active');
    btn.classList.add('is-active');
  } else {
    element.classList.remove('is-active');
    btn.classList.remove('is-active');
  }

  return true;
}

function init() {
  const toggleElements = document.querySelectorAll('[data-toggle]');
  if (toggleElements) {
    toggleElements.forEach((el) => {
      el.addEventListener('click', toggle);
    });
  }
}

export default init();
